import React from "react";

import ResetPasswordComp from "./components/General/ResetPassword.component";
import Header from "./components/General/Header";

const ResetPassword = () => {
  return (
    <>
      <Header />
      <ResetPasswordComp />
    </>
  );
};

export default ResetPassword;
